<template>
  <div>
    <el-carousel height="730px">
      <el-carousel-item>
        <div class="swiper" :style="{'background-image': `url(${require('@/assets/images/index/banner/1.jpg')})`}" @click="goto('/products/1')"></div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="swiper" :style="{'background-image': `url(${require('@/assets/images/index/banner/2.jpg')})`}" @click="goto('/products/3')"></div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="swiper" :style="{'background-image': `url(${require('@/assets/images/index/banner/3.jpg')})`}" @click="goto('/products/4')"></div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="swiper" :style="{'background-image': `url(${require('@/assets/images/index/banner/4.jpg')})`}" @click="goto('/products/2')"></div>
      </el-carousel-item>
    </el-carousel>
    <div class="page-container">
      <div class="sec-title">认识一下我们的超级海藻产品</div>
      <div class="goods-list">
        <el-row :gutter="40">
          <el-col :span="8" v-for="(goods, index) in goodsList" v-bind:key="goods.id">
            <div class="goods-item" @mouseleave="showGoodsImage(index,goods.image1)" @mouseenter="showGoodsImage(index,goods.image2)" @click="goto('/product/'+ goods.id)">
              <img class="goods-image" :src="goods.image==''?goods.image1:goods.image">
              <div class="goods-name">{{goods.name}}</div>
              <div class="goods-ename">{{goods.englishName}}</div>
              <div class="goods-price">￥{{goods.price}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="goods-sec"></div>
      <div class="goods-three">
        <el-row :gutter="0" type="flex">
          <el-col :span="12" :offset="0">
            <img class="image-a" src="https://cdn.shopifycdn.net/s/files/1/0834/3901/files/alternating-banner-1_800x.jpg?v=1613727334">
          </el-col>
          <el-col :span="12" :offset="0">
            <div class="des-wrap">
              <div>
                <div class="sec-title-2">海藻科学</div>
                <div class="sec-des">汇集了海藻显着的健康和美容功效以及地球上最好的天然成分。</div>
                <div class="btn" @click="goto('/about/seaweed')">发现不同之处</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="0" type="flex">
          <el-col :span="12" :offset="0">
            <div class="des-wrap">
              <div>
                <div class="sec-title-2">美容SECRETS博客</div>
                <div class="sec-des">从我们的护肤专家团队那里获得专家提示和灵感。</div>
                <div class="btn" @click="goto('/news')">阅读更多</div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" :offset="0">
            <img class="image-a" src="https://cdn.shopifycdn.net/s/files/1/0834/3901/files/alternating-banner-2_800x.jpg?v=1613727334">
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      goodsList: [
        { id: 14, name: '赋活修复保湿面霜', englishName: 'HYDRA DEW PURE FACIAL MOISTURIZER', price: '990.00', image: '', image1: require('../assets/images/index/goods/a.jpg'), image2: require('../assets/images/index/goods/a-1.jpg') },
        { id: 16, name: '赋活修复眼霜', englishName: 'HYDRA DEW PURE EYE CONTOUR CREAM', price: '860.00', image: '', image1: require('../assets/images/index/goods/b.jpg'), image2: require('../assets/images/index/goods/b-1.jpg') },
        { id: 10, name: '舒缓焕活精华', englishName: 'RED-OUT® SERUM', price: '790.00', image: '', image1: require('../assets/images/index/goods/c.jpg'), image2: require('../assets/images/index/goods/c-1.jpg') },
        { id: 5, name: '臻蓝精华棒', englishName: 'REPÊCHAGE® Rapidex® Marine Exfoliator With Phyto-Marine Actives', price: '560.00', image: '', image1: require('../assets/images/index/goods/d.jpg'), image2: require('../assets/images/index/goods/d-1.jpg') },
        { id: 24, name: '净透控油祛痘套盒', englishName: 'HYDRA MEDIC® GIFT SET', price: '270.00', image: '', image1: require('../assets/images/index/goods/e.jpg'), image2: require('../assets/images/index/goods/e-1.jpg') },
        { id: 12, name: '净透控油海泥修复面膜', englishName: 'HYDRA MEDIC® SEA MUD PERFECTING MASK', price: '390.00', image: '', image1: require('../assets/images/index/goods/f.jpg'), image2: require('../assets/images/index/goods/f-1.jpg') }
      ]
    }
  },
  methods: {
    showGoodsImage (index, image) {
      this.goodsList[index].image = image
    },
    goto (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>
.page-container{
  max-width: 1200px;
  margin: 0 auto 100px;
}
.sec-title{
  text-align: center;
  font-size: 37px;
  font-weight: 400;
  color: #25282a;
  font-style: italic;
  padding: 30px 0;
  line-height: 100px;
}
.swiper{
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
}
.image-a{
  width: 100%;
  height: 100%;
}
.des-wrap{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20%;
  height: 100%;
  box-sizing: border-box;
  color: #25282a;
  background-color: #f1f1f1;
}
.sec-title-2{
  font-size: 32px;
  font-weight: 400;
}
.sec-des{
  font-size: 16px;
  font-weight: 300;
  padding: 20px 0;
}
.btn{
  background-color: #25282a;
  color: white;
  font-size: 14px;
  font-weight: bolder;
  padding: 15px 20px;
  display: inline-block;
  cursor: pointer;
}
.goods-list{
  margin-bottom: 50px;
}
.goods-item{
  box-sizing: border-box;
  background-color: white;
  text-align: center;
  color: #25282a;
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  margin-bottom: 20px;
  border: 1px solid #fff;
  padding: 20px 5px;
  cursor: pointer;
}
.goods-image{
  max-width: 300px;
}
.goods-name{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 30px;
}
.goods-ename{
  height: 40px;
  line-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.goods-price{
  font-weight: 700;
  padding: 10px;
}
</style>
unju
